<form cdkScrollable class="stepper-container page_container" [formGroup]="form">
  <mat-stepper class="stepper_upload_processing" #stepper>
    <mat-step label="{{'inventory.product_inf'|translate}}" class="static_steps">
      <div class="step_container">
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
               {{"inventory.product_information"|translate}}
              </span>
            </div>
            <div class="body_step">
              <div class="content image_content">
                <div class="field">
                  <div class="drop_zone" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)" (click)="fileInput.click()">
                    <span>{{"inventory.drag_and_drop_the_images_here"|translate}}</span>
                  </div>

                  <input type="file" #fileInput (change)="onFileChange($event)" accept="image/jpeg, image/png, image/gif"
                    style="display: none;" multiple>

                  <!-- <div class="image_preview_container">
                    <div *ngIf="uploadedImage" class="image-preview">
                      <img class="element_img" src="data:'';base64, {{uploadedImage}}" alt="Uploaded image" />
                      <button type="button" class="cancel_upl" (click)="cancelImage()">
                        <mat-icon class="cancel_icon">cancel</mat-icon>
                      </button>
                    </div>
                  </div> -->
                  <!-- TO IMPLEMENT LATER, UPLOAD MORE THAN ONE IMAGE  -->
                  <div class="clear-all-container">
                    <ng-container *appHasPermission="submitPermission()">
                      <button *ngIf="uploadedImages.length > 0" class="clear-all-btn" (click)="removeAllImages()">
                        {{"inventory.clear_all_images"|translate}}
                      </button>
                    </ng-container>
                  </div>
                  <div class="image_preview_container">
                    <div *ngFor="let image of uploadedImages" class="image-preview">
                      <img class="element_img" [src]="image.preview" alt="Uploaded image" />
                      <button *appHasPermission="submitPermission()" class="cancel_upl" (click)="removeImage(image.id)">
                        <mat-icon class="cancel_icon">cancel</mat-icon>
                      </button>

                      <div class="bottom-section">
                        <ng-container *appHasPermission="submitPermission()">
                          <button *ngIf="!image.isDefault" class="default-btn make-default-btn"
                                  (click)="setDefault(image.id)">
                            {{"inventory.set_default_image"|translate}}
                          </button>
                        </ng-container>
                        <div *ngIf="image.isDefault" class="default-banner">{{"inventory.default_image"|translate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="field no_flex">
                  <label for="">{{"common.name"|translate}}<span class="red">*</span></label>
                  <input type="text" formControlName="name" [placeholder]="'common.name'|translate">
                  <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">{{"common.required_field"|translate}}</span>
                </div>
                <div class="field no_flex">
                  <label>{{"common.description"|translate}}</label>
                  <ckeditor class="ck_editor" [editor]="Editor" data="" formControlName="description">
                  </ckeditor>
                </div>
                <div class="inline_block">
                  <div class="field equality_field">
                    <label for="">{{"brands.brands"|translate}}</label>
                    <input type="text" [placeholder]="'brands.brands'|translate" formControlName="brandControl" [matAutocomplete]="auto"
                      class="input">
                    <mat-autocomplete #auto="matAutocomplete">
                      <ng-container *ngIf="filteredBrands$ | async as brands">
                        <mat-option *ngFor="let brand of brands" [value]="brand.name" (click)="onBrandSelected(brand)">
                          {{ brand.name }}
                        </mat-option>

                        <ng-container *appHasPermission="{ module: 'product', action: 'create' }">
                          <mat-option [value]="form.value.brandControl" class="add_option"
                            *ngIf="brands.length === 0 && form.value.brandControl"
                            (click)="addNewElement(form.value.brandControl, 'brand')">
                            <img src="assets/icones/add.svg" alt="">
                            {{"common.add"|translate}} "{{ form.value.brandControl }}"
                          </mat-option>
                        </ng-container>
                      </ng-container>
                    </mat-autocomplete>
                  </div>
                  <div class="field equality_field">
                    <label for="">{{"common.status"|translate}}</label>
                    <select name="" id="" formControlName="status">
                      <option selected value="" disabled>{{"common.status"|translate}}</option>
                      <option selected value="Published">{{"Categories.published"|translate}}</option>
                      <option selected value="Draft">{{"common.draft"|translate}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
               {{"inventory.product_type"|translate}}
              </span>
            </div>
            <div class="cards">
              <div class="element_card" (click)="changeTypeProduct('standard')">
                <div class="hearder_card" [class]="productType === 'standard' ? 'blue' : '' ">
                  <mat-slide-toggle [checked]="productType === 'standard'" [disabled]="true">
                  </mat-slide-toggle>
                  <span>{{"inventory.standard_product"|translate}}</span>
                </div>
                <div class="content_card">
                  <img src="assets/icones/hint.svg" alt="">
                  <span>{{"inventory.standard_product_hind"|translate}}</span>
                </div>
              </div>
              <div class="element_card" (click)="changeTypeProduct('variante')">
                <div class="hearder_card variant_header" [class]="productType === 'variante' ? 'blue' : '' ">
                  <mat-slide-toggle [checked]="productType === 'variante'" [disabled]="true">
                  </mat-slide-toggle>
                  <span>{{"inventory.variant_product"|translate}}</span>
                </div>
                <div class="content_card">
                  <img src="assets/icones/hint.svg" alt="">
                  <span>
                    {{"inventory.variant_product_hind"|translate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="step">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"companies.documents_Files"|translate}}
                </span>
                <span class="descr_title">{{"inventory.insert_documents_files_to_this_product" | translate}}</span>
              </div>
              <div>
                  <button class="add_btn " *appHasPermission="submitPermission()" type="button" (click)="docxInput.click()">
                    <img src="assets/icones/add_icon.svg" alt="add_file">
                    <span>{{ "common.add" | translate }}</span>
                    <input
                      #docxInput
                      type="file"
                      (change)="addFiles($event)"
                      style="display: none;"
                      multiple
                    />
                  </button>
              </div>
            </div>
            <span class="light_span"></span>
            <div class="content">
              <table class="listing_table">
                <tbody>
                  <ng-container *ngFor="let file of selectedFiles; let i = index">
                    <tr class="body_table_catalog">
                      <td class="td_block file_block">
                        <img src="../../../../../assets/icones/doc.svg" alt="">
                        <span class="bold_span">{{ file.filename }}</span>
                        <span class="light_span"></span>
                      </td>
                      <td>
                        <button style="color: #404142" class="preview mg_left" (click)="preview(file.data, file.content_type)">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button style="color: #404142; margin: 8px;" class="preview mg_left" (click)="download(file.data, file.filename, file.content_type)">
                          <mat-icon>download</mat-icon>
                        </button>
                        <button *appHasPermission="submitPermission()" (click)="removeFile(i)">
                          <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button class="save_btn_pop_up blue_btn" (click)="next('basic_infos')">
              <span>{{"common.next" | translate | uppercase}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
    </mat-step>
    <mat-step label="{{'inventory.inventory_pricing'|translate}}" class="static_steps" *ngIf="productType === 'standard'">
      <div class="step_container">
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
                {{"inventory.pricing"|translate}}
              </span>
            </div>
            <div class="body_step">
              <div class="content">
                <div class="inline_block pricing_step" [ngClass]="{ 'default-currency-row': addedCurrencies.length > 0 }">
                  <div class="field ">
                    <label for="">{{"inventory.retail_pricee"|translate}} ({{ default_currency?.name }})</label>
                    <input formControlName="sales_price" type="number" [placeholder]="'inventory.retail_price_currency'|translate:{currency: default_currency?.name || '?'}">
                    <span [title]="default_currency?.name || '?'" class="indicate_input">{{ default_currency?.symbol || '?' }}</span>
                  </div>
                  <div class="field ">
                    <label for="">{{"inventory.product_cost_(cogs)"|translate}} ({{ default_currency?.name }})</label>
                    <input type="number" [placeholder]="'inventory.product_cost_(cogs)_currency'|translate:{currency: default_currency?.name || '?'}" formControlName="cost">
                    <span [title]="default_currency?.name || '?'" class="indicate_input">{{ default_currency?.symbol || '?' }}</span>
                  </div>
                </div>
                <div *ngFor="let currency of addedCurrencies" class="inline_block pricing_step">
                  <div class="field" [formGroup]="currency.controls['retail_price']">
                    <label>{{ 'inventory.retail_pricee' | translate }} ({{ currency.data.name }})</label>
                    <input type="number" formControlName="amount" [placeholder]="'inventory.retail_price_currency' | translate:{currency: currency.data.name}" min="0" />
                    <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                  </div>

                  <div class="field" [formGroup]="currency.controls['cost']">
                    <label>{{ "inventory.product_cost_(cogs)" | translate }} ({{ currency.data.name }})</label>
                    <input type="number" formControlName="amount" [placeholder]="'inventory.product_cost_(cogs)_currency' | translate:{currency: currency.data.name}" min="0" />
                    <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                  </div>
                  <button class="remove-currency" *appHasPermission="submitPermission()" type="button" (click)="removeCurrency(currency.data.id)">
                    <img src="assets/icones/delete_btn.svg" alt="">
                  </button>
                </div>
                <div class="btn_attributes">
                  <ng-container *appHasPermission="submitPermission()">
                    <span *ngIf="availableCurrencies.length > 0" class="add-currency-button" #dropdown>
                      <button class="add_attr" type="button" (click)="openCurrenciesDropdown($event)">
                        <img src="../../../../../assets/icones/add_icon.svg" alt="">
                        <span> {{"inventory.add_other_currencies"|translate}}</span>
                      </button>

                      <div *ngIf="showCurrencyDropdown" class="currency-dropdown"
                        [style.top.px]="currenciesDropdown.top"
                        [style.left.px]="currenciesDropdown.left"
                        [style.minWidth.px]="currenciesDropdown.minWidth"
                      >
                        <ul>
                          <li *ngFor="let currency of availableCurrencies" (click)="addCurrency(currency)">
                            {{ currency.name }} ({{ currency.symbol }})
                          </li>
                        </ul>
                      </div>
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="steps_block">
          <div class="step">
            <div class="step_title">
              <span>
                {{"inventory.inventory"|translate}}
              </span>
            </div>
            <div class="content">
              <div class="inline_block pricing_step">
                <div class="field ">
                  <label for="">{{"inventory.sku_code_type"|translate}}</label>
                  <select name="" id="" disabled>
                    <option selected value="">{{"inventory.statics_input"|translate}}</option>
                  </select>
                </div>
                <div class="field ">
                  <label for="">{{"inventory.sKU_code"|translate}}<span class="red">*</span></label>
                  <input value="" type="text" formControlName="sku" [placeholder]="'inventory.sku'|translate">
                  <span class="error_ms" *ngIf="form.get('sku')?.touched && form.get('sku')?.errors">{{"common.required_field"|translate}}</span>
                </div>
                <div class="field ">
                  <label for="">{{"inventory.barcode"|translate}}</label>
                  <input type="number" [placeholder]="'inventory.barcode'|translate " formControlName="barcodeControl" class="input" (input)="sanitize($event)">
                </div>
              </div>
              <div class="inline_block pricing_step">
                <div class="field ">
                  <label for="">{{"inventory.expiration_date"|translate}}</label>
                  <input type="Date" [placeholder]="'inventory.expiration_date'|translate" formControlName="expiry_date" class="input">
                </div>
              </div>
              <div class="form_array_codes" formArrayName="codes">
                <div class="inline_block pricing_step" *ngFor="let code of codes.controls; let i = index" [formGroupName]="i">
                  <div class="field">
                    <label for="">{{ "inventory.label" | translate }}</label>
                    <input type="text" formControlName="label" placeholder="Enter label" />
                    <span class="error_ms" *ngIf="code.get('label')?.touched && code.get('label')?.errors">{{ "common.required_field" | translate }}</span>
                  </div>
                  <div class="field">
                    <div style="display: flex; justify-content: space-between;">
                      <label for="">{{ "inventory.code" | translate }}</label>
                      <div *appHasPermission="submitPermission()" style="height:20px; cursor: pointer;" (click)="removeCode(i)">
                        <img src="assets/icones/delete-circle.svg" alt="">
                      </div>
                    </div>
                    <input type="text" formControlName="value" placeholder="Enter value" />
                    <span class="error_ms" *ngIf="code.get('value')?.touched && code.get('value')?.errors">{{ "common.required_field" | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="insede_seperator"></div>
              <div class="step_title">
                <span>
                  {{"inventory.inventory_levels"|translate}}
                </span>
              </div>
              <div class="content">
               <div class="inline_block pricing_step">
                <div class="field">
                  <label for="quantity">{{ "inventory.current_inventory" | translate }}</label>
                  <input
                    id="quantity"
                    type="number"
                    [placeholder]="'inventory.current_inventory' | translate"
                    formControlName="quantity"
                  />
                  <span class="error_ms" *ngIf="form.get('quantity')?.errors?.['max']">
                    {{ 'validation.max_quantity' | translate }}
                  </span>
                </div>
                <div class="field">
                  <label for="reorder_point">{{ "inventory.re-order_point" | translate }}</label>
                  <input
                    id="reorder_point"
                    type="number"
                    [placeholder]="'inventory.re-order_point' | translate"
                    formControlName="reorder_point"
                  />
                  <span class="error_ms" *ngIf="form.get('reorder_point')?.errors?.['max']">
                    {{ 'validation.max_quantity' | translate }}
                  </span>
                </div>
              </div>
              <div class="inline_block">
                <div class="field" [formGroup]="generalRulesform">
                  <label for="reorder_point">{{"Catalogs.order_quantity_rules"|translate}}</label>
                  <div class="inline_block pricing_step">
                    <div class="field">
                      <input type="number" formControlName="min_qte" (input)="sanitize($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                      <span class="error_ms" *ngIf="generalRulesform.get('min_qte')?.touched  && generalRulesform.get('min_qte')?.hasError('required')">
                        {{"common.required_field" | translate}}
                      </span>
                      <span class="error_ms"  *ngIf="generalRulesform.hasError('minQte')">{{ generalRulesform.getError('minQte') }}</span>
                    </div>
                    <div class="field">
                      <input type="number" formControlName="increment" (input)="sanitize($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                      <span class="error_ms" *ngIf="generalRulesform.get('increment')?.touched && generalRulesform.get('increment')?.hasError('required')">
                        {{"common.required_field" | translate}}
                      </span>
                      <span class="error_ms"  *ngIf="generalRulesform.hasError('increment')">{{ generalRulesform.getError('increment') }}</span>
                      <span class="error_ms"  *ngIf="generalRulesform.hasError('incrementMin')">{{ generalRulesform.getError('incrementMin') }}</span>
                    </div>
                    <div class="field">
                      <input type="number" formControlName="max_qte" (input)="sanitize($event)">
                      <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                      <span class="error_ms" *ngIf="generalRulesform.get('max_qte')?.touched  && generalRulesform.get('max_qte')?.hasError('required')">
                        {{"common.required_field" | translate}}
                      </span>
                      <span class="error_ms" *ngIf="generalRulesform.hasError('minMax')">{{ generalRulesform.getError('minMax') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
          <span>{{"common.back"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="next('standard_inventory')">
            <span>{{"common.next" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
    </mat-step>
    <mat-step label="{{'inventory.variant_inven_price'|translate}}" class="static_steps" *ngIf="productType === 'variante'">
      <div class="step_container">
        <div class="step">
          <div class="step_title">
            <span>
              {{"inventory.variants_management"|translate}}
            </span>
          </div>
          <span>{{"inventory.choose_up_to_three_variable_attributes_for_this_product."|translate}}</span>
          <div class="block_attribute">
            <div class="content inline attributes" *ngFor="let attribute of attributes; let i = index">
              <div class="field attribut category_field">
                <label for="" *ngIf="i === 0">{{"inventory.attribute"|translate}}</label>
                <input type="text" [(ngModel)]="attributes[i].name" [ngModelOptions]="{standalone: true}"
                  (change)="updateAttributeName($event)"  placeholder="{{'inventory.attribute' | translate}}" [disabled]="!!product" (keydown.enter)="$event.preventDefault()">
              </div>
              <div class="field values">
                <label for="" *ngIf="i === 0">{{"inventory.values"|translate}}</label>
                <mat-chip-list #chipList aria-label="Attribute Values">
                  <mat-chip *ngFor="let value of attribute.values; let j = index" (removed)="removeValue(i, j)">
                    {{value}}
                    <button matChipRemove *ngIf="!product">
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </mat-chip>
                  <input placeholder="{{'inventory.values'|translate}}" class="input_chip" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addValue($event, i)" [disabled]="!!product">
                </mat-chip-list>
              </div>
              <ng-container *appHasPermission="submitPermission()">
                <button *ngIf="i !== 0 && !product" class="small_btn " (click)="removeAttr(i)">
                  <img src="assets/icones/red-removed.svg" alt="">
                </button>
              </ng-container>
            </div>
            <div class="btn_attributes">
              <ng-container *appHasPermission="{ module: 'product', action: 'create' }">
                <button *ngIf="attributes.length < 3 && !product" class="add_attr" (click)="addAttribute()">
                  <img src="../../../../../assets/icones/add_icon.svg" alt="">
                  <span> {{"inventory.add_attribute"|translate}}</span>
                </button>
                <button class="add_attr" *ngIf="!checkUpdate && !product" (click)="generateVariants()">
                  <img src="../../../../../assets/icones/add_icon.svg" alt="">
                  <span> {{"inventory.generate_variant"|translate}}</span>
                </button>
              </ng-container>
            </div>
          </div>
          <div *ngIf="variants.length > 0 && productType === 'variante'" class="variantes" [formGroup]="variantsForm">
            <div class="step_title variants_title">
              <span>
                {{variants.length}} {{"inventory.variants_included"|translate}}
              </span>
              <div class="btn_attributes">
                <div class="currencies">
                  {{"common.currencies"|translate}}: 
                  <div class="currency_tag">
                    {{ default_currency?.name }} ({{ default_currency?.symbol }})
                  </div>
                  <div class="currency_tag" *ngFor="let currency of currenciesToDisplay">
                    {{ currency.name }} ({{ currency.symbol }})
                    <button class="remove_currency" *appHasPermission="submitPermission()" (click)="removeCurrency(currency.id)">
                      <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                    </button>
                  </div>
                </div>
                <ng-container *appHasPermission="submitPermission()">
                  <span *ngIf="availableCurrencies.length > 0" class="add-currency-button" #dropdown>
                    <button class="add_attr small_btn_add" type="button" (click)="openCurrenciesDropdown($event)">
                      <img src="../../../../../assets/icones/add_icon.svg" alt="">
                      <span> {{"common.add"|translate}} </span>
                    </button>

                    <div *ngIf="showCurrencyDropdown" class="currency-dropdown"
                      [style.top.px]="currenciesDropdown.top"
                      [style.left.px]="currenciesDropdown.left"
                      [style.minWidth.px]="currenciesDropdown.minWidth"
                    >
                      <ul>
                        <li *ngFor="let currency of availableCurrencies" (click)="addCurrency(currency)">
                          {{ currency.name }} ({{ currency.symbol }})
                        </li>
                      </ul>
                    </div>
                  </span>
                </ng-container>
              </div>
            </div>
            <div class="header_variant th_variant">
              <div>{{"Catalogs.variant"|translate}}</div>
              <div>{{"inventory.sku"|translate}}</div>
              <div>{{"inventory.current_inventory"|translate}}</div>
              <div>{{"inventory.reorder_point"|translate}}</div>
              <div>{{"inventory.retail_pricee"|translate}}</div>
              <div>{{"inventory.product_cost_(cogs)"|translate}}</div>
              <div>{{"common.enabled"|translate}}</div>
            </div>
            <div class="seperater header_panel"></div>
            <div class="div_panel" *ngFor="let variant of variants; let i = index">
              <mat-expansion-panel class="mat_panel">
                <mat-expansion-panel-header>
                  <div class="header_variant">
                    <div class="first_th_variant cursor">
                      <div (change)="getVariantImg($event, variant.id)" for="upload" >
                        <label >
                          <img class="icon_user"
                                [src]="variant.image ? 'data:;base64,' + variant.image : defaultVariantAvatar"
                                alt="image variante">
                          <input class="file" type="file" id="upload" accept="image/jpeg, image/png, image/gif" style="display: none;">
                        </label>
                      </div>
                      {{ variant.values.join('/ ')}}
                    </div>
                    <div>
                      <input class="input_table" [value]="variantsForm.get('sku_' + variant.id)?.value" type="text" [formControlName]="'sku_' + variant.id" [placeholder]="'inventory.sku'|translate"
                      (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                      (keydown.space)="$event.stopPropagation()">
                    </div>
                    <div>
                      <input class="input_table" type="number" [placeholder]="'inventory.current_inventory' | translate"
                        [formControlName]="'quantity_' + variant.id" [value]="variantsForm.get('quantity_' + variant.id)?.value"
                        (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation()">
                    </div>
                    <div>
                      <input class="input_table" type="number" [placeholder]="'inventory.minimum_inventory' | translate"
                        [formControlName]="'reorder_point_' + variant.id" [value]="variantsForm.get('reorder_point_' + variant.id)?.value"
                        (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation()">
                    </div>
                    <div>
                      <div class="input_price_container">
                        <input class="input_table" type="number" [formControlName]="'sales_price_' + variant.id" [value]="variantsForm.get('sales_price_' + variant.id)?.value"
                        [placeholder]="'inventory.retail_price_currency' | translate:{currency: default_currency?.name || '?'}"
                        (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                        <span class="indicate_input">{{ default_currency?.symbol || '?' }}</span>
                      </div>
                     
                    </div>
                    <div>
                      <div class="input_price_container">
                        <input class="input_table" type="number" [formControlName]="'cost_' + variant.id"
                        [value]="variantsForm.get('cost_' + variant.id)?.value" [placeholder]="'inventory.product_cost_(cogs)_currency' | translate:{currency: default_currency?.name || '?'}"
                        (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                        (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                        <span class="indicate_input">{{ default_currency?.symbol || '?' }}</span>
                      </div>
                    </div>
                    <div>
                      <mat-slide-toggle class="checkbox_table" [formControlName]="'enabled_' + variant.id" [checked]="variantsForm.get('enabled_' + variant.id)?.value"
                      (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                      (keydown.space)="$event.stopPropagation()"></mat-slide-toggle>
                    </div>
                  </div>
                </mat-expansion-panel-header>
                <div class="content_panel">
                  <div class="content">
                    <div class="variants_block">
                      <div class="variant_img">
                        <div class="title_panels">{{"inventory.photo"|translate}}</div>
                        <div class="content_img" (change)="getVariantImg($event, variant.id)" for="upload">
                          <input class="file" type="file" id="upload" accept="image/jpeg, image/png, image/gif">
                          <img [class]="variant.image ? 'icon_variant' : 'icon_user'"
                            [src]="variant.image ? 'data:;base64,' + variant.image : defaultVariantAvatar"
                            alt="image variante">
                            <span *ngIf="!variant.image">{{"inventory.click_to_upload"|translate}}</span>
                            <button *ngIf="variant.image" class="cancel_upl_variant" (click)="cancelImageVariant(variant.id)">
                              <mat-icon class="cancel_icon">cancel</mat-icon>
                            </button>
                        </div>
                      </div>
                      <div class="skus_codes">
                        <div class="title_panels">{{"inventory.sKU_code"|translate}}</div>
                        <div class="inline_block">
                          <div class="field ">
                            <label for="">{{"inventory.sku_code_type"|translate}}</label>
                            <select name="" id="" disabled>
                              <option selected value="">{{"inventory.statics_input"|translate}}</option>
                            </select>
                          </div>
                          <div class="field ">
                            <label for="">{{"inventory.sKU_code"|translate}}<span class="red">*</span></label>
                            <input [value]="variantsForm.get('sku_' + variant.id)?.value" type="text" [formControlName]="'sku_' + variant.id" placeholder="Sku">
                          </div>
                          <div class="field ">
                            <label for="">{{"inventory.barcode"|translate}}</label>
                            <input type="number" [placeholder]="'inventory.barcode'|translate" type="text" [formControlName]="'bar_code_' + variant.id" class="input" (input)="sanitize($event)">
                          </div>
                        </div>
                        <div class="inline_block">
                          <div class="field ">
                            <label for="">{{"inventory.expiration_date"|translate}}</label>
                            <input type="Date" [placeholder]="'inventory.expiration_date'|translate" [formControlName]="'expiry_date_' + variant.id"  class="input">
                          </div>
                        </div>
                        <div [formArrayName]="'codes_' + variant.id" class="form_array_codes">
                          <div
                            class="inline_block pricing_step"
                            *ngFor="let code of getCodesArray(variant.id)?.controls; let i = index"
                            [formGroupName]="i"
                          >
                            <div class="field">
                              <label for="">{{ "inventory.label" | translate }}</label>
                              <input type="text" formControlName="label" placeholder="Enter label" />
                              <span class="error_ms" *ngIf="code.get('label')?.touched && code.get('label')?.errors">
                                {{ "common.required_field" | translate }}
                              </span>
                            </div>
                            <div class="field">
                              <label for="">{{ "inventory.code" | translate }}</label>
                              <input type="text" formControlName="value" placeholder="Enter value" />
                              <span class="error_ms" *ngIf="code.get('value')?.touched && code.get('value')?.errors">
                                {{ "common.required_field" | translate }}
                              </span>
                            </div>
                            <div class="delete_code">
                              <button class="remove_code" *appHasPermission="submitPermission()" (click)="removeVariantCode(variant.id, i)" type="button">
                                <img src="assets/icones/delete_btn.svg" alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="insede_seperator"></div>
                    <div class="variants_block">
                      <div class="details_block left_step_variants">
                        <div class="title_panels">
                          <span>
                            {{"inventory.inventory_levels"|translate}}
                          </span>
                        </div>
                        <div class="content">
                          <div class="inline_block">
                            <div class="field">
                              <label for="">{{"inventory.current_inventory"|translate}}</label>
                              <input value="" type="number" [placeholder]="'inventory.current_inventory'|translate"
                              [formControlName]="'quantity_' + variant.id" [value]="variantsForm.get('quantity_' + variant.id)?.value">                            </div>
                            <div class="field">
                              <label for="">{{"inventory.re-order_point"|translate}}</label>
                              <input value="" type="number" [placeholder]="'inventory.min_inventory'|translate"
                              [formControlName]="'reorder_point_' + variant.id" [value]="variantsForm.get('reorder_point_' + variant.id)?.value">                            </div>
                          </div>
                          <div class="inline_block">
                            <div class="field">
                              <label for="reorder_point">{{"Catalogs.order_quantity_rules"|translate}}</label>
                              <div class="inline_block">
                                <div class="field">
                                  <input type="number" [formControlName]="'min_qte_' + variant.id" [value]="variantsForm.get('min_qte_' + variant.id)?.value" (input)="sanitize($event)">
                                  <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                                </div>
                                <div class="field">
                                  <input type="number" [formControlName]="'increment_' + variant.id" [value]="variantsForm.get('increment_' + variant.id)?.value" (input)="sanitize($event)">
                                  <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                                </div>
                                <div class="field">
                                  <input type="number" [formControlName]="'max_qte_' + variant.id" [value]="variantsForm.get('max_qte_' + variant.id)?.value" (input)="sanitize($event)">
                                  <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="small_seperator"></div>
                      <div class="details_block right_step_variants pricing_step">
                        <div class="title_panels">
                          <span>
                            {{"inventory.pricing"|translate}}
                          </span>
                        </div>
                          <div class="content">
                            <div class="inline_block">
                              <div>
                                <div class="field ">
                                  <label for="">{{"inventory.retail_price"|translate}} <span class="red">*</span></label>
                                  <input [formControlName]="'sales_price_'+ variant.id" [value]="variantsForm.get('sales_price_' + variant.id)?.value" type="number" [placeholder]="'inventory.retail_pricee'|translate ">
                                  <span class="indicate_input">€</span>
                                  <span class="error_ms" *ngIf="variantsForm.get('sales_price_' + variant.id)?.touched && variantsForm.get('sales_price_' + variant.id)?.errors?.['min']">
                                    {{"inventory.price_must_be_positive"|translate}}
                                  </span>
                                    <span class="error_ms" *ngIf="variantsForm.get('sales_price_' + variant.id)?.touched && variantsForm.get('sales_price_' + variant.id)?.errors?.['required']">
                                    {{"common.required_field"|translate}}
                                  </span>
                                </div>
                                <div *ngFor="let currency of addedCurrencies">
                                  <div *ngIf="currency.variantId === variant.id" class="input_price_container" [formGroup]="currency.controls.retail_price">
                                    <input class="input_table" type="number" formControlName="amount"
                                      [value]="currency.controls.retail_price?.get('amount')?.value"
                                      [placeholder]="'inventory.retail_price_currency' | translate:{currency: currency.data.name}"
                                      (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                                      (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                                    <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div class="field ">
                                  <label for="">{{"inventory.product_cost_(cogs)"|translate}}</label>
                                  <input type="number" [placeholder]="'inventory.product_cost_(cogs)'|translate" [formControlName]="'cost_' + variant.id" [value]="variantsForm.get('cost_' + variant.id)?.value" >
                                  <span class="indicate_input">€</span>
                                  <span class="error_ms" *ngIf="variantsForm.get('cost_' + variant.id)?.touched && variantsForm.get('cost_' + variant.id)?.errors?.['min']">
                                    {{"inventory.price_must_be_positive"|translate}}
                                  </span>
                                </div>
                                <div *ngFor="let currency of addedCurrencies">
                                  <div *ngIf="currency.variantId === variant.id" class="input_price_container" [formGroup]="currency.controls.cost">
                                    <input class="input_table" type="number" formControlName="amount"
                                      [value]="currency.controls.cost?.get('amount')?.value"
                                      [placeholder]="'inventory.product_cost_(cogs)_currency' | translate:{currency: currency.data.name}"
                                      (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                                      (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                                    <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      </div>
      <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
          <span>{{"common.back"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="next('variants_step')">
            <span>{{"common.next" | translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
    </mat-step>
    <mat-step label="{{'organize.organize'|translate}}" class="static_steps">
      <div *ngIf="currentForm==='addProduct'">
        <div class="step_container orgenaze_step">
          <div class="step">
            <div class="step_title">
              <span>
                {{"organize.organize"|translate}}
              </span>
            </div>
            <div class="content">
              <div class="field">
                  <label for="">{{"Categories.categories"|translate}}</label>
                  <mat-chip-list #chipCategoryList>
                    <mat-chip *ngFor="let category of categoriesSelected$ | async" (removed)="cancelCategory(category.id)">
                      {{category.name}}
                      <button matChipRemove>
                        <mat-icon style="color: #868E96;">cancel</mat-icon>
                      </button>
                    </mat-chip>
                    <input class="input_chip" [placeholder]="'inventory.categories' | translate" #fruitInput formControlName="categoryControl"
                      [matAutocomplete]="autoCategory" [matChipInputFor]="chipCategoryList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                  </mat-chip-list>
                  <mat-autocomplete #autoCategory="matAutocomplete">
                    <ng-container *ngIf="filteredCategories$ | async as categories">
                      <mat-option *ngFor="let category of categories" [value]="category.name" (click)="onCategorySelected(category)">
                        {{category.name}}
                      </mat-option>
                      <mat-option [value]="form.value.categoryControl"
                        *ngIf="categories.length === 0 && form.value.categoryControl"
                        (click)="addNewElement(form.value.categoryControl, 'category')">
                        {{ "Categories.no_category_available"|translate}}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </div>
                <div class="field">
                  <label for="">{{"Labels.labels"|translate}}</label>
                  <mat-chip-list #chipList>
                    <mat-chip *ngFor="let tag of tagsSelected$ | async" (removed)="cancelTag(tag.id)">
                      {{tag.name}}
                      <button matChipRemove>
                        <mat-icon style="color: #868E96;">cancel</mat-icon>
                      </button>
                    </mat-chip>
                    <input class="input_chip" [placeholder]="'inventory.New_Label_placeholder' | translate" #fruitInput formControlName="tagControl"
                      [matAutocomplete]="auto1" [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                  </mat-chip-list>
                  <mat-autocomplete #auto1="matAutocomplete">
                    <ng-container *ngIf="filteredTags$ | async as tags">
                      <mat-option *ngFor="let tag of tags" [value]="tag.name" (click)="onTagSelected(tag)">
                        {{tag.name}}
                      </mat-option>
                      <mat-option [value]="form.value.tagControl" class="add_option"
                        *ngIf="tags.length === 0 && form.value.tagControl"
                        (click)="addNewElement(form.value.tagControl, 'tag')">
                        <img src="assets/icones/add.svg" alt="">
                        {{"common.add"|translate}} "{{ form.value.tagControl }}"
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </div>
            </div>
          </div>
          <div class="step">
            <div class="step_title inline_title">
              <div>
                <span>
                  {{"Catalogs.catalogs"|translate}} ({{selectedCatalogs.length}})
                </span>
                <span class="descr_title">{{"inventory.catalogs_associated_with_this_product"|translate}}</span>
              </div>
              <button class="add_btn" *appHasPermission="submitPermission()" (click)="goTo('insertCatalogs')">
                <img src="assets/icones/add_icon.svg" alt="">
                <span>{{"common.add"|translate}}</span>
              </button>
            </div>
            <div class="content">
              <!-- <div *ngIf="!selectedCatalogs || selectedCatalogs.length === 0">
                No catalogs available for this product.
              </div> -->
              <table class="listing_table" *ngIf="selectedCatalogs.length > 0">
                <tbody>
                  <ng-container *ngFor="let catalog of selectedCatalogs let i = index">
                    <tr class="body_table">
                      <td class="td_block">
                        <span class="bold_span">{{catalog.name}}</span>
                        <span class="light_span"></span>
                      </td>
                      <td>
                        <button *appHasPermission="submitPermission()" (click)="removeCatalog(catalog.id)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button class="action_btn btn_edit" (click)="next()">
            <span>{{"companies.skip"|translate}}</span>
          </button>
          <button class="save_btn_pop_up blue_btn" (click)="next('selectedValues')">
              <span>{{"common.next" | translate | uppercase}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
      <app-insert-catalogs-product
        *ngIf="currentForm==='insertCatalogs'"
        [selectedCatalogsO]="selectedCatalogs"
        (cancelCatalogs)="canceled()"
        (saveCatalogs)="onSaveCatalogs($event)"
        >
      </app-insert-catalogs-product>
    </mat-step>
    <mat-step label="{{'common.summary'|translate}}" class="static_steps summary_step">
      <div *ngIf="currentForm==='addProduct'">
        <div class="steps_block">
          <div class="step">
            <div class="step_title inline_title">
              <span>
               {{"inventory.product_information"|translate}}
              </span>
              <button class="add_btn" (click)="editBasicInfo()">
                <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                <span>{{"common.edit"|translate}}</span>
              </button>
            </div>
            <div class="body_step sam_step">
              <div class="content image_content">
                    <img *ngIf="getDefaultImage()" class="element_img" src="data:'';base64, {{getDefaultImage()}}" alt="Uploaded image" />
                    <img *ngIf="!getDefaultImage()" class="element_img no_image" src="../../../../../assets/icones/default-image-product.svg" alt="Uploaded image" />
                    <div class="image_preview_container">
                      <div *ngFor="let image of uploadedImages" class="image-preview">
                        <img class="element_img" [src]="image.preview" alt="Uploaded image" />
                        <div class="bottom-section">
                          <div *ngIf="image.isDefault" class="default-banner">{{"inventory.default_image"|translate}}</div>
                        </div>
                      </div>
                    </div>
              </div>
              <div class="content summary_content">
                <div class="field no_flex">
                  <label for="">{{"common.name"|translate}}</label>
                  <div class="inline_div">{{form.get('name')?.value}}</div>
                </div>
                <div class="field no_flex">
                  <label>{{"common.description"|translate}}</label>
                  <div class="inline_div" [innerHTML]="form.get('description')?.value"></div>
                </div>
                <div class="inline_block">
                  <div class="field no_flex">
                    <label>{{"brands.brands"|translate}}</label>
                    <div class="inline_div">{{this.form.get('brandControl')?.value}}</div>
                  </div>
                  <div class="field no_flex">
                    <label>{{"inventory.product_type"|translate}}</label>
                    <div class="inline_div">{{productType === 'variante' ? 'Variant product' : 'Standard product'}}</div>
                  </div>
                  <div class="field no_flex">
                    <label>{{"common.status"|translate}}</label>
                    <div class="inline_div">{{this.form.get('status')?.value}}</div>
                  </div>
                </div>
                <div class="attr_block"  *ngIf="variants.length > 0 && productType === 'variante'">
                  <div class="field no_flex variants_basics">
                    <label>{{"Catalogs.variant"|translate}}({{this.variants.length}})</label>
                    <button class="add_btn" (click)="editVariantProduct()">
                      <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                      <span>{{"common.edit"|translate}}</span>
                    </button>
                  </div>
                  <div class="field customers_chip" *ngFor="let attr of attributes">
                    <label class="att_name" for="">{{attr.name}}</label>
                    <mat-chip-list #chipList1>
                      <mat-chip *ngFor="let value of attr.values" (click)="selectAttributeValue(attr.name, value)"
                      [selected]="isSelected(attr.name, value)">
                        {{value}}
                      </mat-chip>
                    </mat-chip-list>
                  </div>
                </div>
                <div class="field">
                  <div class="step_title inline_title">
                    <div>
                      <span>
                        {{"companies.documents_Files" | translate}}
                      </span>
                    </div>
                    <button class="add_btn" (click)="editFiles(selectedFiles)">
                      <img src="assets/icones/edit_catalog.svg" alt="">
                      <span>{{ "common.edit" | translate }}</span>
                    </button>
                  </div>
                  <div class="content files_block">
                      <ng-container  *ngFor="let file of selectedFiles; let i = index">
                        <div class="td_block file_block">
                          <img src="../../../../../assets/icones/doc.svg" alt="">
                          <span>
                            {{file.filename}}
                          </span>
                          <button style="color: #404142; margin: 8px;" class="preview mg_left" (click)="download(file.data, file.filename, file.content_type)">
                            <mat-icon>download</mat-icon>
                          </button>
                          <button style="color: #404142; margin: 8px;" class="preview mg_left" (click)="preview(file.data, file.content_type)">
                            <mat-icon>visibility</mat-icon>
                          </button>
                          <button *appHasPermission="submitPermission()" (click)="removeFile(i)">
                            <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                          </button>
                        </div>
                      </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="steps_block_sammary">
          <div class="left_steps_block_sammary">
            <div>
              <div class="step">
                <div class="step_title inline_title">
                  <span>
                   {{"inventory.pricing"|translate}}
                  </span>
                  <button class="add_btn" *ngIf="productType === 'standard'" (click)="editPricingProduct()">
                    <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                    <span>{{"common.edit"|translate}}</span>
                  </button>
                  <button class="add_btn" *ngIf="productType === 'variante'" (click)="editVariantProduct()">
                    <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                    <span>{{"common.edit"|translate}}</span>
                  </button>
                </div>
                <div class="body_step" *ngIf="productType === 'standard'">
                  <div class="content">
                    <div class="inline_block pricing_step">
                      <div class="field">
                        <label for="">{{"inventory.retail_pricee"|translate}}</label>
                        <div class="inline_div">
                          <span class="price-chip" [title]="default_currency?.name || '?'">
                            {{form.get('sales_price')?.value}} {{default_currency?.symbol || '?'}}
                          </span>
                          <span class="price-chip" *ngFor="let price of getPricesForSelectedVariant('retail_price')">
                              {{ price.amount }} {{ price.currencySymbol }}
                            </span>
                        </div>
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.product_cost_(cogs)"|translate}}</label>
                        <div class="inline_div">
                          <span class="price-chip">
                            {{form.get('cost')?.value}} {{default_currency?.symbol || '?'}}
                          </span>
                          <span class="price-chip" *ngFor="let price of getPricesForSelectedVariant('cost')">
                              {{ price.amount }} {{ price.currencySymbol }}
                            </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="body_step body_step_variant" *ngIf="productType === 'variante'" [formGroup]="variantsForm">
                  <div *ngIf="selectedVariant" class="content">
                    <div class="variant_name">Variant:  {{ selectedVariant.values.join('/ ') }}</div>
                    <div class="inline_block pricing_step">
                      <div class="field ">
                        <label for="">{{"inventory.retail_pricee"|translate}}</label>
                        <div class="inline_div">
                            <span class="price-chip">
                              {{variantsForm.get('sales_price_' + selectedVariant.id)?.value}} {{default_currency?.symbol || '?'}}
                            </span>
                            <span class="price-chip" *ngFor="let price of getPricesForSelectedVariant('retail_price')">
                              {{ price.amount }} {{ price.currencySymbol }}
                            </span>
                        </div>
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.product_cost_(cogs)"|translate}}</label>
                        <div class="inline_div">
                          <span class="price-chip">
                            {{variantsForm.get('cost_' + selectedVariant.id)?.value}} {{default_currency?.symbol || '?'}}
                          </span>
                          <span class="price-chip" *ngFor="let price of getPricesForSelectedVariant('cost')">
                            {{ price.amount }} {{ price.currencySymbol }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="steps_block">
              <div class="step">
                <div class="step_title inline_title">
                  <span>
                    {{"inventory.inventory"|translate}}
                  </span>
                  <button class="add_btn" *ngIf="productType === 'standard'" (click)="editInventoryProduct()">
                    <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                    <span>{{"common.edit"|translate}}</span>
                  </button>
                  <button class="add_btn" *ngIf="productType === 'variante'" (click)="editVariantProduct()">
                    <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                    <span>{{"common.edit"|translate}}</span>
                  </button>
                </div>
                <div class="body_step" *ngIf="productType === 'standard'">
                  <div class="content">
                    <div class="inline_block">
                      <div class="field ">
                        <label for="">{{"inventory.sku_code_type"|translate}}</label>
                        <div class="inline_div">{{"inventory.statics_input"|translate}}</div>
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.sKU_code"|translate}}</label>
                        <div class="inline_div">{{form.get('sku')?.value}}</div>
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.barcode"|translate}}</label>
                        <div class="inline_div">{{form.get('barcodeControl')?.value}}</div>
                      </div>
                    </div>
                    <div class="i_separator"></div>
                    <div class="inline_block ">
                      <div class="field ">
                        <label for="">{{"inventory.expiration_date"|translate}}</label>
                        <div class="inline_div">{{form.get('expiry_date')?.value}}</div>
                      </div>
                    </div>
                    <div class="insede_seperator"></div>
                    <div class="step_title">
                      <span>
                        {{"inventory.inventory_levels"|translate}}
                      </span>
                    </div>
                    <div class="content">
                      <div class="inline_block pricing_step">
                        <div class="field">
                          <label for="">{{"inventory.current_inventory"|translate}}</label>
                          <div class="inline_div">{{form.get('quantity')?.value}}</div>
                        </div>
                        <div class="field">
                          <label for="">{{"inventory.re-order_point"|translate}}</label>
                          <div class="inline_div">{{form.get('reorder_point')?.value}}</div>
                        </div>
                      </div>
                      <div class="inline_block pricing_step">
                        <div class="field">
                          <label for="">{{"Catalogs.min" | translate}}</label>
                          <div class="inline_div">{{generalRulesform.get('min_qte')?.value}}</div>
                        </div>
                        <div class="field">
                          <label for="">{{"Catalogs.increment"| translate}}</label>
                          <div class="inline_div">{{generalRulesform.get('increment')?.value}}</div>
                        </div>
                        <div class="field">
                          <label for="">{{"Catalogs.max" | translate}}</label>
                          <div class="inline_div">{{generalRulesform.get('max_qte')?.value}}</div>
                        </div>
                      </div>
                      <div class="i_separator"></div>
                    </div>
                  </div>
                </div>
                <div class="body_step body_step_variant body_step_variant_iventory" *ngIf="productType === 'variante'">
                  <div *ngIf="selectedVariant" class="content inventory_variants">
                    <div class="variant_name">{{"Catalogs.variant"|translate}} : {{ selectedVariant.values.join('/ ') }}</div>
                    <div>
                      <div class="inline_block pricing_step custom_sam_block">
                        <div class="field ">
                          <label for="">{{"inventory.sku_code_type"|translate}}</label>
                          <div class="inline_div">{{"inventory.statics_input"|translate}}</div>
                        </div>
                        <div class="field ">
                          <label for="">{{"inventory.sKU_code"|translate}}</label>
                          <div class="inline_div">{{variantsForm.get('sku_' + selectedVariant.id)?.value}}</div>
                        </div>
                        <div class="field ">
                          <label for="">{{"inventory.barcode"|translate}}</label>
                          <div class="inline_div">{{variantsForm.get('bar_code_' + selectedVariant.id)?.value}}</div>
                        </div>
                      </div>
                      <div class="inline_block pricing_step">
                        <div class="field ">
                          <label for="">{{"inventory.expiration_date"|translate}}</label>
                          <div class="inline_div">---</div>
                        </div>
                      </div>
                      <div class="insede_seperator"></div>
                      <div class="step_title">
                        <span>
                          {{"inventory.inventory_levels"|translate}}
                        </span>
                      </div>
                      <div class="content">
                        <div class="inline_block pricing_step">
                          <div class="field">
                            <label for="">{{"inventory.current_inventory"|translate}}</label>
                            <div class="inline_div">{{variantsForm.get('quantity_' + selectedVariant.id)?.value}}</div>
                          </div>
                          <div class="field">
                            <label for="">{{"inventory.re-order_point"|translate}}</label>
                            <div class="inline_div">{{variantsForm.get('reorder_point_' + selectedVariant.id)?.value}}</div>
                          </div>
                        </div>
                        <div class="inline_block pricing_step">
                          <div class="field">
                            <label for="">{{"Catalogs.min" | translate}}</label>
                            <div class="inline_div">{{variantsForm.get('min_qte_' + selectedVariant.id)?.value}}</div>
                          </div>
                          <div class="field">
                            <label for="">{{"Catalogs.increment"| translate}}</label>
                            <div class="inline_div">{{variantsForm.get('increment_' + selectedVariant.id)?.value}}</div>
                          </div>
                          <div class="field">
                            <label for="">{{"Catalogs.max" | translate}}</label>
                            <div class="inline_div">{{variantsForm.get('max_qte_' + selectedVariant.id)?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right_steps_block_sammary">
            <div class="step">
              <div class="step_title inline_title">
                <span>
                  {{"organize.organize"|translate}}
                </span>
                <button class="add_btn" (click)="editOrganizeProduct()">
                  <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                  <span>{{"common.edit"|translate}}</span>
                </button>
              </div>
              <div class="body_step">
                <div class="content customers_chip">
                  <div class="inline_block custom_org_block">
                    <div class="field">
                      <label for="">{{"inventory.categories"|translate}}</label>
                      <div class="inline_div">{{form.get('categoryControl')?.value}}</div>
                    </div>
                    <div class="field">
                      <label for="">{{"Labels.labels"|translate}}</label>
                      <mat-chip-list #chipList1>
                        <mat-chip *ngFor="let tag of tagsSelected$ | async">
                          {{tag.name}}
                        </mat-chip>
                      </mat-chip-list>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="step">
              <div class="step_title inline_title">
                <div>
                  <span>
                   {{"Catalogs.catalogs"|translate}} ({{selectedCatalogs.length}})
                  </span>
                  <span class="descr_title">{{"inventory.catalogs_associated_with_this_product"|translate}}</span>
                </div>
                <button class="add_btn" *appHasPermission="submitPermission()" (click)="goTo('insertCatalogs')">
                  <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
                  <span>{{"common.edit"|translate}}</span>
                </button>
              </div>
              <div class="content">
                <div *ngIf="!selectedCatalogs || selectedCatalogs.length === 0">
                 {{"inventory.no_cat"|translate}}
                </div>
                <table class="listing_table" *ngIf="selectedCatalogs.length > 0">
                  <tbody>
                    <ng-container *ngFor="let catalog of selectedCatalogs let i = index">
                      <tr class="body_table">
                        <td class="td_block">
                          <span class="bold_span">{{catalog.name}}</span>
                          <span class="light_span"></span>
                        </td>
                        <td>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="submet_btns">
          <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span>{{"common.back"|translate | uppercase | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
          </button>
          <button class="save_btn_pop_up green_btn" *appHasPermission="submitPermission()" (click)="save()">
              <span>{{"inventory.add_product"|translate | uppercase}}</span>
              <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
          </button>
        </div>
      </div>
      <app-insert-catalogs-product
      *ngIf="currentForm==='insertCatalogs'"
      [selectedCatalogsO]="selectedCatalogs"
      (cancelCatalogs)="canceled()"
      (saveCatalogs)="onSaveCatalogs($event)"
      >
    </app-insert-catalogs-product>
    </mat-step>
  </mat-stepper>
</form>
